import { atom } from 'nanostores'

export const isLogin = atom(false)
export function setIsLogin(value: boolean) {
	isLogin.set(value)
}
